export default __webpack_public_path__ + "static/media/h1.91eb35b8.jpg";